import { Component, OnInit, Input, Output, EventEmitter, forwardRef, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { takeWhile } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { DEFAULT_LANGUAGE } from '@ibe.config';

@Component({
	selector: 'app-radio-input-group-indra',
	templateUrl: './radio-input-group.indra.component.html',
	styleUrls: ['./radio-input-group.component.scss'],
	host: {
		class: 'app-radio-input-group'
	},
	providers: [
		{
			/**
			 * Custom Control value accessor
			 */
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => INDRARadioInputGroupComponent),
			multi: true
		}
	]
})
export class INDRARadioInputGroupComponent implements OnInit, ControlValueAccessor, OnDestroy {
	@Input() _value = '';
	@Input() label: string;
	@Input() inline: boolean = false;
	@Input() name: string;
	@Input() options: { label: string, selected?: boolean, id: string }[];

	@Output() optionChanged = new EventEmitter();

	propagateChange = (_: any) => { };

	isAlive = true;
	triedToSubmit = false;

	allSubscriptions: Subscription[] = [];
	submitSubsription: Subscription;

	constructor(
		private ibeAdminService: INDRAIbeAdminService,
		private paymentService: PaymentService
	) { }

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.propagateChange(this._value);
	}

	ngOnInit() {
		this.submitSubsription = this.ibeAdminService.loadTranslations("tap",
			["shoppingBasket"],
			(sessionStorage.getItem('language') ? sessionStorage.getItem('language') : DEFAULT_LANGUAGE));
		this.paymentService.triedToSubmit
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(triedToSubmit => {
				this.triedToSubmit = triedToSubmit;
			});
		this.allSubscriptions.push(this.submitSubsription);
	}

	trackByRadioId(radioBttn) {
		return radioBttn.id;
	}

	onRadioChange(event) {
		let activeOption = null;

		this.options.forEach((option) => {
			if (!event[option.id]) {
				option['selected'] = false;
			} else {
				activeOption = option.id;
				option['selected'] = true;
			}
		});

		this.optionChanged.emit(activeOption);
	}

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: any): void { }

	writeValue(value: any) {
		this.value = value;
	}

	ngOnDestroy() {
		for (let sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}
}
